import { VodafoneTariffState } from '@tymbe/schema/enums';
import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const deactivatedVodafoneTariffQueryId = 'admin/vodafoneTariff/deactivated';

export const DeactivatedTab = () => {
  return (
    <VodafoneTariffTable
      queryId={deactivatedVodafoneTariffQueryId}
      state={VodafoneTariffState.DEACTIVATED}
      tabName="deactivated"
    />
  );
};
